import React from "react";
import { NowPlayingProps } from "../lib";

export default ({}: NowPlayingProps) => {
  return <div>Now Playing</div>;
};
